// extracted by mini-css-extract-plugin
export default {"details__topBarContainer":"AdminReportsView_details__topBarContainer__Dwr2v"};